import React, { useState, useEffect } from 'react';
import { AlertTriangle, LogOut } from 'lucide-react';

const ImpersonationBanner = () => {
  const [session, setSession] = useState(null);

  useEffect(() => {
    const stored = sessionStorage.getItem('impersonation');
    if (stored) setSession(JSON.parse(stored));
  }, []);

  if (!session) return null;

  const handleStop = () => {
    localStorage.setItem('token', session.original_token);
    sessionStorage.removeItem('impersonation');
    window.location.href = '/super-admin';
  };

  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-amber-500 text-black py-1.5 px-4 flex items-center justify-center gap-3 text-xs font-bold" data-testid="impersonation-banner">
      <AlertTriangle className="w-4 h-4" />
      <span>MODE SUPPORT ACTIF — {session.company?.name}</span>
      <button onClick={handleStop} className="flex items-center gap-1 px-3 py-1 bg-black/20 rounded-full hover:bg-black/30 transition-colors" data-testid="stop-impersonation-banner-btn">
        <LogOut className="w-3 h-3" /> Quitter
      </button>
    </div>
  );
};

export default ImpersonationBanner;
